// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinner_container__3OrYs","active":"LoadingSpinner_active__icLUN","rotate":"LoadingSpinner_rotate__ZC3Hh"};